import { createSlice } from '@reduxjs/toolkit';
import { DefaultRootStateProps } from 'types';

const initialState: DefaultRootStateProps['loadingCursor'] = {
    isShow: false,
    talkIsShow: false,
};
const slice = createSlice({
    name: 'loading-cursor',
    initialState,
    reducers: {
        showLoadingCursor: (state) => {
            state.isShow = true;
        },
        hideLoadingCursor: (state) => {
            state.isShow = false;
        },
        showTalk: (state) => {
            state.talkIsShow = true;
        },
        hideTalk: (state) => {
            state.talkIsShow = false;
        },
    },
});
export default slice.reducer;
export const { showLoadingCursor, hideLoadingCursor, showTalk, hideTalk } = slice.actions;
